module.exports = __webpack_public_path__ + "img/lifeboat.405bca0a.png";